import Button from '@material-ui/core/Button';
import * as globals from '@wandb/weave/common/css/globals.styles';
import {hexToRGB} from '@wandb/weave/common/css/globals.styles';
import {IconVersionsLayers} from '@wandb/weave/components/Icon';
import React from 'react';
import styled from 'styled-components';

import {useBetaFeature} from '../../../util/useBetaFeature';

const WeaveModeWarning = () => {
  const usingWeave = useBetaFeature('weave1');

  return (
    <TextBox>
      <IconVersionsLayers style={iconStyle} />
      <StyledText>Using Weave 1.0</StyledText>
      <Button style={buttonStyle} onClick={usingWeave.toggleBetaFeature}>
        Turn off
      </Button>
    </TextBox>
  );
};

export default WeaveModeWarning;

const TextBox = styled.div`
  background-color: ${hexToRGB(globals.MOON_950, 0.12)};
  border-radius: 5px;
  margin-top: 5px;
  padding-top: 5px;
  margin-bottom: 5px;
  padding-bottom: 5px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 10px;
`;

const StyledText = styled.div`
  text-align: left;
  width: 115px;
  justify-content: center;
`;

const iconStyle: React.CSSProperties = {
  width: '20px',
  height: '20px',
  position: 'relative',
  marginLeft: '8px',
  marginRight: '8px',
};

const buttonStyle: React.CSSProperties = {
  backgroundColor: 'transparent',
  fontSize: 'inherit',
  fontWeight: 600,
  color: 'white',
  marginLeft: '2px',
  marginRight: '12px',
  paddingRight: '0px',
  paddingLeft: '0px',
  paddingTop: '0px',
  paddingBottom: '0px',
};
